"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rectangle = void 0;
const gl_matrix_1 = require("gl-matrix");
const ShapeHelper_1 = require("./ShapeHelper");
/**
 * Rectangle Shape
 */
class Rectangle {
    /**
     * Private constructor, use static creation methods instead.
     *
     * @param p1 1st point of the rectangle
     * @param p2 2nd point of the rectangle
     * @param p3 3rd point of the rectangle
     * @param p4 4th point of the rectangle
     */
    constructor(p1, p2, p3, p4) {
        this.p1 = p1;
        this.p2 = p2;
        this.p3 = p3;
        this.p4 = p4;
    }
    /**
     * Creates a Rectangle instance described by the rectangle JSON.
     *
     * @param contourJson The rectangle JSON
     */
    static fromJson(RectangleJson) {
        return new Rectangle(gl_matrix_1.vec2.fromValues(RectangleJson.P1[0], RectangleJson.P1[1]), gl_matrix_1.vec2.fromValues(RectangleJson.P2[0], RectangleJson.P2[1]), gl_matrix_1.vec2.fromValues(RectangleJson.P3[0], RectangleJson.P3[1]), gl_matrix_1.vec2.fromValues(RectangleJson.P4[0], RectangleJson.P4[1]));
    }
    /**
     * Creates an JSON object out of the rectangle instance.
     */
    toJson() {
        return {
            P1: [this.p1[0], this.p1[1]],
            P2: [this.p2[0], this.p2[1]],
            P3: [this.p3[0], this.p3[1]],
            P4: [this.p4[0], this.p4[1]],
        };
    }
    /**
     * Test if the point is inside the rectangle or on the rectangle contour.
     *
     * @param point A 2D point
     */
    isPointInShape(point) {
        return ShapeHelper_1.ShapeHelper.isPointInShape([this.p1, this.p2, this.p3, this.p4], point) !== ShapeHelper_1.IsPointInShape.OutsideOfShape;
    }
    /**
     * Transform the rectangle by the given matrix.
     *
     * @param transform The transformation matrix.
     */
    transform(transform) {
        const transformedP1 = gl_matrix_1.vec2.create();
        const transformedP2 = gl_matrix_1.vec2.create();
        const transformedP3 = gl_matrix_1.vec2.create();
        const transformedP4 = gl_matrix_1.vec2.create();
        gl_matrix_1.vec2.transformMat2d(transformedP1, this.p1, transform);
        gl_matrix_1.vec2.transformMat2d(transformedP2, this.p2, transform);
        gl_matrix_1.vec2.transformMat2d(transformedP3, this.p3, transform);
        gl_matrix_1.vec2.transformMat2d(transformedP4, this.p4, transform);
        return new Rectangle(transformedP1, transformedP2, transformedP3, transformedP4);
    }
}
exports.Rectangle = Rectangle;
//# sourceMappingURL=Rectangle.js.map